'use strict';

const linkSelector = '.global-nav__link';
const itemSelector = '.global-nav__item';
const itemListSelector = '.global-nav__child';
const backSelector = '.global-nav__item--back';
const itemActiveClass = 'global-nav__item--active';
const parentActiveClass = 'is-active';
const menuActiveClass = 'nav-open-inverted';
const menuBtnId = 'nav-btn';

export function init() {
    const links = document.querySelectorAll(linkSelector);
    const backLinks = document.querySelectorAll(backSelector);
    const menuBtn = document.getElementById(menuBtnId);

    if (!links.length) {
        return;
    }

    links.forEach(link => {
        const process = () => {
            link.closest('ul').querySelectorAll(itemSelector).removeClass(itemActiveClass);
            link.closest('li').classList.add(itemActiveClass);

            document.body.classList.add(menuActiveClass);

            if (link.nextElementSibling) {
                link.closest('ul').classList.add(parentActiveClass);
                link.nextElementSibling.nextElementSibling.classList.remove(parentActiveClass);
            } else {
                link.closest('ul').classList.remove(parentActiveClass);
            }
        }

        if (link.nextElementSibling) {
            link.nextElementSibling.addEventListener('click', process);
        }
    });

    backLinks.forEach(backLink => {
        const backProcess = () => {
            backLink.closest('.global-nav__item.has-child').classList.remove(itemActiveClass);
            backLink.closest('.global-nav__item.has-child').closest('ul').classList.remove(parentActiveClass);

            if(backLink.parentElement.classList.contains('global-nav--level-1')) {
                document.body.classList.remove(menuActiveClass);
            }
        }

        backLink.addEventListener('click', backProcess);
    });

    if(menuBtn) {
        const resetMenu = () => {
            setTimeout( () => {
                links.forEach(link => {
                    link.closest('ul').querySelectorAll(itemSelector).removeClass(itemActiveClass);
                    link.closest('ul').classList.remove(parentActiveClass);
                    document.body.classList.remove(menuActiveClass);
                });
             }, 250);
        }

        menuBtn.addEventListener('click', resetMenu);
    }

    const process_active_menu = () => {
        const link = location.href.replace(location.origin, '');
        const linkObj = document.querySelector(`a.global-nav__link[href='${link}']`);
        if (!linkObj) return;

        linkObj.classList.add('active');

        let currentUL = linkObj.closest(itemListSelector);
        let upperLI = currentUL ? currentUL.closest(itemSelector) : null;

        while (currentUL && upperLI) {
            upperLI.classList.add(itemActiveClass);
            upperLI.parentNode.classList.add(parentActiveClass);

            currentUL = upperLI.closest(itemListSelector);
            upperLI = currentUL ? currentUL.closest(itemSelector) : null;
        }
    }

    process_active_menu()
}

export default { init }

